const HeaderData = [
    {
        title: 'Index',
        link: '/'
    },
    {
        title: 'About Us',
        link: '/page/about-us'
    },
    {
        title: 'Services',
        link: '/page/our-services'
    },
    {
        title: 'Contact Us',
        link: '/page/contact-modern'
    }
]

export default HeaderData
